import { FC } from 'react';

interface ErrataBoxProps {
    articleType?: number;
    errata?: number;
    submAt?: FlagYn;
}

export const ErrataBox: FC<ErrataBoxProps> = ({ articleType, errata, submAt }) => {
    const errataBtnName = (errata?: number) => {
        let errataType = '';
        let errataText = '';

        switch (errata) {
            case 1:
                errataType = 'good';
                errataText = '정답';
                break;
            case 2:
                errataType = 'bad';
                errataText = '오답';
                break;
            case 3:
                errataType = 'average';
                errataText = '부분정답';
                break;
            case 4:
                errataType = '';
                errataText = '수정 전';
                break;
            default:
                errataType = '';
                errataText = '';
                break;
        }

        return { errataType, errataText };
    };

    const errataType = errataBtnName(errata).errataType;
    const errataText = errataBtnName(errata).errataText;

    if (articleType === 20 || errata === 4 || submAt === 'N') {
        return <>-</>;
    } else {
        return (
            <span className={`ico-point ${errataType}`}>
                <span className="sr-only">{errataText}</span>
            </span>
        );
    }
};
